export default __webpack_public_path__ + "3303fb4db14d0b2c98ad6a7b8dd42d54.png";